// eslint-disable no-console

import React from 'react';
import {
  DEFAULT_BADGE_NOTIFICATIONS,
  DEFAULT_COUNTDOWN,
  DEFAULT_FONT_SIZE,
  DEFAULT_HIGH_CONTRAST,
  DEFAULT_HINTS_EFFECTS,
  DEFAULT_MUSIC_PLAYBACK,
  DEFAULT_SOUND_EFFECTS
} from './Config';

const PreferencesContext = React.createContext({
  musicPlayback: DEFAULT_MUSIC_PLAYBACK,
  setMusicPlayback: (_value: boolean) =>
    // eslint-disable-next-line no-console
    console.log('setMusicPlayback handler should be defined'),

  soundEffects: DEFAULT_SOUND_EFFECTS,
  setSoundEffects: (_value: boolean) =>
    // eslint-disable-next-line no-console
    console.log('setSoundEffects handler should be defined'),

  hintsEffects: DEFAULT_HINTS_EFFECTS,
  setHintsEffects: (_value: boolean) =>
    // eslint-disable-next-line no-console
    console.log('setHintsEffects handler should be defined'),

  // Countdown timers in timed lesson tasks (word games, dictation). Stored inverted on
  // the profile as `disableCountdown`.
  countdown: DEFAULT_COUNTDOWN,
  setCountdown: (_value: boolean) =>
    // eslint-disable-next-line no-console
    console.log('setCountdown handler should be defined'),

  badgeNotifications: DEFAULT_BADGE_NOTIFICATIONS,
  setBadgeNotifications: (_value: boolean) =>
    // eslint-disable-next-line no-console
    console.log('setBadgeNotifications handler should be defined'),

  fontSize: DEFAULT_FONT_SIZE,
  // eslint-disable-next-line no-console
  setFontSize: (_value: number) => console.log('setFontSize handler should be defined'),

  highContrast: DEFAULT_HIGH_CONTRAST,
  setHighContrast: (_value: boolean) =>
    // eslint-disable-next-line no-console
    console.log('setHighContrast handler should be defined'),

  onboardingVideoShowed: false,
  setOnboardingVideoShowed: (_value: boolean) =>
    // eslint-disable-next-line no-console
    console.log('setOnboardingVideoShowed handler should be defined')
});

export default PreferencesContext;
